import { makeAutoObservable } from 'mobx';
import {fullName} from 'shared/tools';

class GoogleUserViewModel {
  selected = false;
  firstName = '';
  lastName = '';
  email = '';

  get name() {
    return fullName(this);
  }

  constructor({name, primaryEmail}) {
    makeAutoObservable(this);

    this.firstName = name.givenName;
    this.lastName = name.familyName;
    this.email = primaryEmail;
  }

  toJS() {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      invitationEmail: this.email
    };
  }
}

export default GoogleUserViewModel;
